/**
 * Site-wide display rename: "Charcoal Grey" / "Charcoal Gray" -> "Dark Brown".
 * Runs on initial DOM load and watches for dynamically-added content
 * (cart drawer, predictive search, AJAX-rendered product cards, etc.).
 * Purely visual: Shopify product/variant data is untouched.
 */
(function() {
  'use strict';

  var PATTERN = /Charcoal\s+Gr[ea]y/gi;
  var REPLACEMENT = 'Dark Brown';
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1 };
  var ATTRS_TO_SCAN = ['alt', 'title', 'aria-label', 'placeholder', 'value'];

  function shouldSkip(node) {
    var p = node.parentNode;
    while (p) {
      if (p.tagName && SKIP_TAGS[p.tagName]) return true;
      p = p.parentNode;
    }
    return false;
  }

  function replaceTextNodes(root) {
    if (!root || !root.nodeType) return;
    var startNode = root.nodeType === 1 ? root : document.body;
    if (!startNode || !startNode.ownerDocument) return;
    var walker = document.createTreeWalker(startNode, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      PATTERN.lastIndex = 0;
      if (!PATTERN.test(node.nodeValue)) continue;
      if (shouldSkip(node)) continue;
      PATTERN.lastIndex = 0;
      node.nodeValue = node.nodeValue.replace(PATTERN, REPLACEMENT);
    }
  }

  function replaceAttributes(root) {
    if (!root || !root.querySelectorAll) return;
    var selector = ATTRS_TO_SCAN.map(function(a) { return '[' + a + '*="Charcoal" i]'; }).join(',');
    var els;
    try { els = root.querySelectorAll(selector); } catch (e) { return; }
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      for (var j = 0; j < ATTRS_TO_SCAN.length; j++) {
        var attr = ATTRS_TO_SCAN[j];
        var v = el.getAttribute(attr);
        if (!v) continue;
        PATTERN.lastIndex = 0;
        if (!PATTERN.test(v)) continue;
        PATTERN.lastIndex = 0;
        el.setAttribute(attr, v.replace(PATTERN, REPLACEMENT));
      }
    }
    // Also check the root itself
    if (root.nodeType === 1 && root.getAttribute) {
      for (var k = 0; k < ATTRS_TO_SCAN.length; k++) {
        var a = ATTRS_TO_SCAN[k];
        var rv = root.getAttribute(a);
        if (!rv) continue;
        PATTERN.lastIndex = 0;
        if (PATTERN.test(rv)) {
          PATTERN.lastIndex = 0;
          root.setAttribute(a, rv.replace(PATTERN, REPLACEMENT));
        }
      }
    }
  }

  function runAll(root) {
    var target = root || document.body;
    if (!target) return;
    replaceTextNodes(target);
    replaceAttributes(target);
  }

  function init() {
    runAll(document.body);
    if (!window.MutationObserver || !document.body) return;
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1) {
              runAll(n);
            } else if (n.nodeType === 3 && n.nodeValue) {
              PATTERN.lastIndex = 0;
              if (PATTERN.test(n.nodeValue) && !shouldSkip(n)) {
                PATTERN.lastIndex = 0;
                n.nodeValue = n.nodeValue.replace(PATTERN, REPLACEMENT);
              }
            }
          }
        } else if (m.type === 'characterData' && m.target && m.target.nodeValue) {
          var t = m.target;
          PATTERN.lastIndex = 0;
          if (PATTERN.test(t.nodeValue) && !shouldSkip(t)) {
            PATTERN.lastIndex = 0;
            t.nodeValue = t.nodeValue.replace(PATTERN, REPLACEMENT);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
